<template>
  <main-layout>
    <template #header>
      <main-header :title="'배치 관리' | translate" />
    </template>
    <template #feature />
    <template #toolbar>
      <main-toolbar style="width: 100%">
        <div class="d-flex justify-end align-items-center" style="width: 100%">
          조회 시각:
          <span v-if="loadTime"> {{ loadTime }}</span>
          <v-btn
            class="mx-2 button-position"
            dark
            small
            color="primary"
            @click="loadBatchManager"
          >
            재조회
          </v-btn>
        </div>
      </main-toolbar>
    </template>
    <template #body>
      <div style="width: 100%; height: 100%; overflow: auto">
        <div class="d-flex align-items-center justify-start mb-2">
          배치 강제 정지 여부: {{ resData.forceSuspension ? resData.forceSuspension.codeValue : '' }}
          <v-btn
            class="mx-2 button-position"
            dark
            small
            color="primary"
            @click="updateSuspension(resData.forceSuspension && resData.forceSuspension.codeValue === 'Y' ? 'N' : 'Y')"
          >
            {{
              resData.forceSuspension && resData.forceSuspension.codeValue === 'Y' ? '재기동' : '정지'
            }}
          </v-btn>
        </div>
        <div>
          <table style="width: 100%">
            <tr>
              <th style="width: 300px; min-width: 300px; max-width: 300px">
                서비스 명
              </th>
              <th style="width: 100px; min-width: 100px; max-width: 100px">
                시작 시간 (GMT+9)
              </th>
              <th style="width: 90px; min-width: 90px; max-width: 90px">
                사용 여부
              </th>
              <th style="width: 90px; min-width: 90px; max-width: 90px">
                강제 기동
              </th>
              <th style="width: 120px; min-width: 120px; max-width: 120px">
                마지막 수행 상태
              </th>
              <th style="width: 180px; min-width: 180px; max-width: 180px">
                마지막 성공 일시 (UTC)
              </th>
              <th style="width: 180px; min-width: 180px; max-width: 180px">
                마지막 실패 일시 (UTC)
              </th>
              <th style="width: 200px; min-width: 200px; max-width: 200px">
                메세지
              </th>
              <th style="width: 200px; min-width: 200px; max-width: 200px">
                설명
              </th>
            </tr>
            <tr v-for="item in resData.batchManager" :key="`batch-manager-${item.id}`">
              <td :title="item.serviceName" style="text-align: left; width: 300px; min-width: 300px; max-width: 300px">
                {{ item.serviceName }}
              </td> <!--서비스 명-->
              <td :title="item.afterStartTime" style="width: 100px; min-width: 100px; max-width: 100px">
                {{ item.afterStartTime }}
              </td> <!--시작 시간-->
              <td :title="item.useYn" style="width: 90px; min-width: 90px; max-width: 90px">
                {{ item.useYn }}
                <br>
                <v-btn
                  class="mx-2 button-position"
                  dark
                  small
                  color="primary"
                  @click="updateBatchManager(item, 'N')"
                >
                  {{
                    item.useYn === 'Y' ? '사용안함' : '사용함'
                  }}
                </v-btn>
              </td> <!--사용 여부-->
              <td :title="item.forceYn" style="width: 90px; min-width: 90px; max-width: 90px">
                {{ item.forceYn }}
                <br>
                <v-btn
                  class="mx-2 button-position"
                  dark
                  small
                  color="primary"
                  @click="updateBatchManager(item, 'ㅛ')"
                >
                  {{
                    item.forceYn === 'Y' ? '강제 실행 안함' : '강제 실행'
                  }}
                </v-btn>
              </td> <!--강제 기동-->
              <td :title="item.lastStatus" style="width: 120px; min-width: 120px; max-width: 120px">
                {{ item.lastStatus }}
              </td> <!--마지막 수행 상태-->
              <td :title="item.lastExecutionDatetime" style="width: 180px; min-width: 180px; max-width: 180px">
                {{ item.lastExecutionDatetime }}
              </td> <!--마지막 성공 일시-->
              <td :title="item.lastFailedDatetime" style="width: 180px; min-width: 180px; max-width: 180px">
                {{ item.lastFailedDatetime }}
              </td> <!--마지막 실패 일시-->
              <td :title="item.comment" style="width: 200px; min-width: 200px; max-width: 200px">
                {{ item.comment }}
              </td> <!--메세지-->
              <td :title="item.description" style="text-align: left; width: 200px; min-width: 200px; max-width: 200px">
                {{ item.description }}
              </td> <!--설명-->
            </tr>
          </table>
        </div>
      </div>
    </template>
  </main-layout>
</template>

<script>
import {PATH} from "@/constants";
import MainHeader from "@/components/common/layout/MainHeader";
import MainLayout from "@/components/common/layout/MainLayout";
import MainToolbar from "@/components/common/layout/MainToolbar";
import TotalCodeOptions from "@/assets/options/TotalCodeOptions.vue";

export default {
  name: "BatchManagerComp",
  components: {
    MainLayout,
    MainHeader,
    MainToolbar,
  },
  mixins: [TotalCodeOptions],
  data() {
    return {
      isLoading: false,
      loadTime: undefined,
      resData: {
        forceSuspension: undefined,
        batchManager: [],
      }
    }

  },
  computed: {},
  watch: {},
  created() {
    this.loadBatchManager();
  },
  methods: {
    async loadBatchManager() {
      try {
        if (this.loading) {
          alert('데이터 조회중입니다.')
          return
        }
        this.loading = true;
        this.resData.batchManager.splice(0, this.resData.batchManager.length)
        const reqArr = []
        reqArr.push(this.$request(PATH.BATCH.FORCE_SUSPENSION).post().enqueue())
        reqArr.push(this.$request(PATH.BATCH.BATCH_MANAGER).post().enqueue())
        const result = await Promise.all(reqArr)
        this.resData.forceSuspension = result[0]
        this.resData.batchManager.push(...result[1].data)
      } catch (e) {
        console.log(e)
      } finally {
        this.loading = false;
        this.loadTime = this.$now()
      }
    },

    async updateSuspension(codeValue) {
      try {
        const result = await this.$request(PATH.BATCH.FORCE_SUSPENSION_UPDATE)
          .setObject(codeValue)
          .catch()
          .enqueue()
        if (result) {
          alert('변경 성공')
        }
      } catch (e) {
        alert(`업데이트 중 문제가 발생하였습니다. ${e}`)
      } finally {
        this.loadBatchManager()
      }
    },

    async updateBatchManager(item, forceChange) {
      if(!confirm('상태를 변경하시겠습니까?')){
        return
      }

      if (forceChange === 'Y') {
        item.forceYn = item.forceYn === 'Y' ? 'N' : 'Y'
      } else {
        item.useYn = item.useYn === 'Y' ? 'N' : 'Y'
      }
      try {
        const result = await this.$request(PATH.BATCH.BATCH_MANAGER_UPDATE).setObject({
          ...item
        }).catch().enqueue()
        if (result) {
          alert('변경 성공')
        }
      } catch (e) {
        alert(`업데이트 중 문제가 발생하였습니다. ${e}`)
      } finally {
        this.loadBatchManager()
      }
    },
  },
}
</script>

<style scoped>
table {
  border-collapse: collapse;
}
table tr td {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  padding: 4px 8px;
  font-size: 12px;
}
table tr th{
  background: #0c98fe;
  color: white;
}
table tr th,
table tr td {
  border: 1px solid #eeeeee;
}

</style>
